// Which next step one recommendation row offers.
//
// It depends on whether an ERP can take the order — a rec whose supplier,
// location or items are not linked cannot become a PO, and offering "Review &
// create" there earns a rejection at save. The row's downloads are not decided
// here: exporting reads engine output the merchant already owns, so every row
// offers them (RecommendationRowActions). A blocked row is in fact the one most
// worth exporting: it is the order they have to progress by hand while the
// linkage gets sorted out.
//
// Pinned by recommendationRowActions.test.js.

/** What the row's next step is. */
export const ROW_PRIMARY = {
  CREATE_PO: 'createPO',
  // The one block a merchant can clear from this screen.
  LINK_SUPPLIER: 'linkSupplier',
  // location_not_linked / item_not_linked are resolved in the ERP Resolve
  // gate, not inline — the row states why and the page banner points there.
  BLOCKED: 'blocked',
};

/**
 * @param {null|{orderable: boolean, reason: string}} erpOrderBlock
 *   `erp_order_block` off the row. Null unless an ERP owns supplier master.
 * @returns {{primary: string, blockReason: string|null}}
 */
export function recommendationRowActions(erpOrderBlock) {
  const blocked = !!(erpOrderBlock && !erpOrderBlock.orderable);
  if (!blocked) {
    return { primary: ROW_PRIMARY.CREATE_PO, blockReason: null };
  }
  return {
    primary: erpOrderBlock.reason === 'supplier_not_linked'
      ? ROW_PRIMARY.LINK_SUPPLIER
      : ROW_PRIMARY.BLOCKED,
    blockReason: erpOrderBlock.reason,
  };
}
